"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginBase = void 0;
var PluginBase = /** @class */ (function () {
    function PluginBase(ctx) {
        this.ctx = ctx;
    }
    return PluginBase;
}());
exports.PluginBase = PluginBase;
